import useProductLikesActions from './useProductLikesActions'

export default useProductLikesActions
